import { render } from "./SkillsTable.vue?vue&type=template&id=6bd2ce45&scoped=true"
import script from "./SkillsTable.vue?vue&type=script&lang=js"
export * from "./SkillsTable.vue?vue&type=script&lang=js"

import "./SkillsTable.vue?vue&type=style&index=0&id=6bd2ce45&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd2ce45"]])

export default __exports__